const titleClass = '.flexible-content__title';

// Long words (e.g. "ARCHITECTURE") can be wider than narrow text columns.
// Shrink only the titles that overflow, so the rest keep the design size.
const fitTitles = () => {
  document.querySelectorAll(titleClass).forEach((title) => {
    title.style.removeProperty('font-size');

    if (title.scrollWidth <= title.clientWidth) {
      return;
    }

    const fontSize = parseFloat(getComputedStyle(title).fontSize);
    title.style.setProperty('font-size', `${Math.floor(fontSize * (title.clientWidth / title.scrollWidth))}px`);
  });
};

let frame;
const scheduleFit = () => {
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(fitTitles);
};

window.addEventListener('load', () => {
  document.fonts.ready.then(fitTitles);
  window.addEventListener('resize', scheduleFit);
});
